module.exports = __webpack_public_path__ + "static/media/avatar-4.432714a6.png";